/* ============================================================
   NeoSpherium · branded media loader (signature touch).
   Every product/media square holds the NS kinetic-rings emblem, drawn on
   load (SVG stroke animation), until its photo loads and fades in over it.
   Inspired by maison loading states (e.g. Brunello Cucinelli's crest skeleton).
   One reusable script · injects the emblem placeholder behind each <img> in the
   target wrappers and wires the fade-in. CSS (.ns-ph/.ns-emblem/.ns-fade-img) in
   ns-components.css. Monochrome (Stage-1.0-safe), performance-light.
   ============================================================ */
(function () {
  var SEL = '.edit__img, .blog-card__img, .split__img, .pdp__media-main, .pdp__shot';
  var EMBLEM =
    '<span class="ns-ph" aria-hidden="true">' +
      '<svg class="ns-emblem" viewBox="0 0 100 100" fill="none">' +
        '<path class="ns-ring ns-ring--n" d="M28 67 L28 33 L46 67 L46 33"></path>' +
        '<path class="ns-ring ns-ring--s" d="M72 40 C72 34 54 33 54 42 C54 50 72 50 72 58 C72 67 54 66 54 60"></path>' +
      '</svg>' +
    '</span>';

  function wire(img) {
    img.classList.add('ns-fade-img');
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load', function () { img.classList.add('is-loaded'); });
      img.addEventListener('error', function () { img.classList.add('is-loaded'); });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll(SEL).forEach(function (w) {
      if (w.dataset.nsMedia) return;
      var img = w.querySelector('img');
      if (!img) return;
      w.dataset.nsMedia = '1';
      w.insertAdjacentHTML('afterbegin', EMBLEM);
      wire(img);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Re-run when Shopify section rerenders (theme editor / cart drawer swaps)
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
